// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { CONTROLLERS } from "@lib/constants"
import axios from "axios"

export const getUser = createAsyncThunk("appUsers/getUser", async (userId) => {
  try {
    if (!userId) throw new Error("No user ID found in cookies")
    const response = await axios.get(`${CONTROLLERS.opus.endpoint}/Users/${userId}`)
    const formatedRoles = {}
    response.data.roles.map((role) => {
      formatedRoles[role.name] = role.state
    })
    return { ...response.data, roles: formatedRoles }
  } catch (error) {
    return { error }
  }
})

export const appUsersSlice = createSlice({
  name: "appUsers",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {
    // resetFormAndPersonData: (state) => {
    //   state.selectedPerson = null
    //   state.formData = null
    // },
    // setFormData: (state, action) => {
    //   state.formData = action.payload
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.selectedUser = action.payload
    })
    // .addCase(getAllData.fulfilled, (state, action) => {
    //   state.allData = action.payload
    // })
    // .addCase(getData.fulfilled, (state, action) => {
    //   state.data = action.payload.data
    //   state.params = action.payload.params
    //   state.total = action.payload.totalPages
    // })
  }
})

// export const { resetFormAndPersonData, setFormData } = appUsersSlice.actions
export default appUsersSlice.reducer
